import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {AddProjects} from './AddProject';
import {ViewProject} from './ViewProject';
import {ProjectDashboardScreens} from './ProjectDashboard';
import {Routes} from 'navigation/Routes';
import {ScreenWithLayout} from 'components/common/screen-layouts';

const ProjectStack = createNativeStackNavigator();

export function ProjectScreen() {
  return (
    <ProjectStack.Navigator screenOptions={{headerShown: false}}>
      <ProjectStack.Screen name={Routes.VIEWPROJECT}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <ViewProject {...screenProps} />
          </ScreenWithLayout>
        )}
      </ProjectStack.Screen>
      <ProjectStack.Screen name={Routes.ADDPROJECT}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <AddProjects {...screenProps} />
          </ScreenWithLayout>
        )}
      </ProjectStack.Screen>
      <ProjectStack.Screen
        name={Routes.PROJECTDASHBOARD}
        component={ProjectDashboardScreens}
      />
    </ProjectStack.Navigator>
  );
}
